import { faClock } from "@fortawesome/free-solid-svg-icons";

export const attendanceData = [
//   {
//     title: "On-Time Rate",
//     value: "84%",
//     change: 2.5,
//     changePositive: true,
//     description: "Employees arriving on time",
//     icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//   <path d="M11.0002 20.6668C16.0628 20.6668 20.1668 16.5628 20.1668 11.5002C20.1668 6.43755 16.0628 2.3335 11.0002 2.3335C5.93755 2.3335 1.8335 6.43755 1.8335 11.5002C1.8335 16.5628 5.93755 20.6668 11.0002 20.6668Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M11 6V11.5L14.6667 13.3333" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>,
//   },
//   {
//     title: "Total Attendance",
//     value: "10",
//     change: 1.2,
//     changePositive: true,
//     description: "Total employees in attendance",
//     icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//   <path d="M14.6668 19.75V17.9167C14.6668 16.9442 14.2805 16.0116 13.5929 15.3239C12.9053 14.6363 11.9726 14.25 11.0002 14.25H5.50016C4.5277 14.25 3.59507 14.6363 2.90744 15.3239C2.2198 16.0116 1.8335 16.9442 1.8335 17.9167V19.75" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M14.6665 3.36719C15.4528 3.57103 16.1491 4.03018 16.6462 4.67258C17.1433 5.31498 17.413 6.10425 17.413 6.91652C17.413 7.72879 17.1433 8.51807 16.6462 9.16046C16.1491 9.80286 15.4528 10.262 14.6665 10.4659" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M20.1665 19.75V17.9166C20.1659 17.1042 19.8955 16.315 19.3978 15.6729C18.9 15.0308 18.2031 14.5722 17.4165 14.3691" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M8.25016 10.5833C10.2752 10.5833 11.9168 8.94171 11.9168 6.91667C11.9168 4.89162 10.2752 3.25 8.25016 3.25C6.22512 3.25 4.5835 4.89162 4.5835 6.91667C4.5835 8.94171 6.22512 10.5833 8.25016 10.5833Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>,
//   },
//   {
//     title: "Average Late Time",
//     value: "30 min",
//     change: 1.8,
//     changePositive: false,
//     description: "Employees absent",
//     icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//   <path d="M19.9192 17L12.5859 4.16671C12.426 3.88456 12.1941 3.64988 11.9139 3.48661C11.6337 3.32333 11.3152 3.2373 10.9909 3.2373C10.6666 3.2373 10.3481 3.32333 10.0679 3.48661C9.78767 3.64988 9.55579 3.88456 9.39589 4.16671L2.06256 17C1.90093 17.28 1.81618 17.5976 1.8169 17.9208C1.81761 18.2441 1.90377 18.5614 2.06663 18.8406C2.2295 19.1197 2.46328 19.3509 2.74428 19.5106C3.02528 19.6704 3.34351 19.753 3.66672 19.75H18.3334C18.655 19.7497 18.971 19.6648 19.2494 19.5037C19.5278 19.3427 19.759 19.1112 19.9197 18.8326C20.0804 18.5539 20.1649 18.2379 20.1648 17.9162C20.1648 17.5946 20.0801 17.2786 19.9192 17Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M11 8.75V12.4167" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M11 16.0835H11.01" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>,
//   },
//    {
//     title: "Missed Clock outs",
//     value: "9%",
//     change: 0.5,
//     changePositive: true,
//     description: "Percentage of missed clock outs",
//     icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//   <path d="M19.2499 11.5C19.7559 11.5 20.1712 11.0885 20.1208 10.5852C19.9094 8.4807 18.9768 6.51403 17.4811 5.01859C15.9853 3.52316 14.0184 2.591 11.9139 2.38013C11.4097 2.32972 10.999 2.74497 10.999 3.25097V10.5843C10.999 10.8274 11.0956 11.0606 11.2675 11.2325C11.4394 11.4044 11.6726 11.501 11.9157 11.501L19.2499 11.5Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M19.4425 15.0659C18.8594 16.445 17.9473 17.6603 16.7859 18.6054C15.6246 19.5506 14.2494 20.1969 12.7806 20.4878C11.3118 20.7787 9.7941 20.7054 8.36018 20.2742C6.92626 19.8431 5.61978 19.0672 4.55498 18.0145C3.49017 16.9618 2.69946 15.6643 2.25196 14.2354C1.80446 12.8065 1.71381 11.2897 1.98793 9.81765C2.26204 8.34562 2.89258 6.96315 3.82442 5.7911C4.75626 4.61905 5.96102 3.69311 7.33338 3.09424" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>,
//   },
  {
    title: "iPad Devices In Use",
    value: "87/120",
    change: 3.2,
    changePositive: false,
    description: "Active devices in field",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
  <path d="M16.4998 2.3335H5.49984C4.48732 2.3335 3.6665 3.15431 3.6665 4.16683V18.8335C3.6665 19.846 4.48732 20.6668 5.49984 20.6668H16.4998C17.5124 20.6668 18.3332 19.846 18.3332 18.8335V4.16683C18.3332 3.15431 17.5124 2.3335 16.4998 2.3335Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 17H11.01" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>,
  },
];

export const ipadData = [
   {
    title: "Total",
    name:"total",
    value: "120",
    change: 1.2,
    changePositive: true,
    description: "Devices registered",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
  <path d="M16.4998 2.3335H5.49984C4.48732 2.3335 3.6665 3.15431 3.6665 4.16683V18.8335C3.6665 19.846 4.48732 20.6668 5.49984 20.6668H16.4998C17.5124 20.6668 18.3332 19.846 18.3332 18.8335V4.16683C18.3332 3.15431 17.5124 2.3335 16.4998 2.3335Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 17H11.01" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>,
  },
  {
    title: "In Use",
      name:"in_use",
    value: "87",
    change: 1.8,
    changePositive: false,
    description: "Currently active",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M14.0182 4.25L6.6849 11.5833L3.35156 8.25" stroke="#030213" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>,
  },
//    {
//     title: "Available",
//       name:"available",
//     value: "27",
//     change: 0.5,
//     changePositive: true,
//     description: "Ready for use",
//     icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//   <path d="M16.4998 2.3335H5.49984C4.48732 2.3335 3.6665 3.15431 3.6665 4.16683V18.8335C3.6665 19.846 4.48732 20.6668 5.49984 20.6668H16.4998C17.5124 20.6668 18.3332 19.846 18.3332 18.8335V4.16683C18.3332 3.15431 17.5124 2.3335 16.4998 2.3335Z" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M11 17H11.01" stroke="#030213" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>,
//   },
  {
    title: "Issues",
      name:"issues",
    value: "8",
    change: 3.2,
    changePositive: false,
    description: "Maintenance or offline",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M8.8654 14.9168C12.5473 14.9168 15.5321 11.9321 15.5321 8.25016C15.5321 4.56826 12.5473 1.5835 8.8654 1.5835C5.1835 1.5835 2.19873 4.56826 2.19873 8.25016C2.19873 11.9321 5.1835 14.9168 8.8654 14.9168Z" stroke="#030213" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.86523 5.5835V8.25016" stroke="#030213" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.86523 10.9165H8.8719" stroke="#030213" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>,
  },
];
// lateOffendersData.js

const lateOffenders = [
  { name: "Alex Johnson", title: "Engineer", lateCount: 6, avgLate: "25 mins" },
  { name: "Sara Williams", title: "Designer", lateCount: 5, avgLate: "18 mins" },
  { name: "David Smith", title: "Manager", lateCount: 4, avgLate: "22 mins" },
  { name: "Emma Davis", title: "QA Analyst", lateCount: 7, avgLate: "30 mins" },
  { name: "Liam Brown", title: "DevOps", lateCount: 3, avgLate: "17 mins" },
  { name: "Olivia Wilson", title: "Product Owner", lateCount: 8, avgLate: "28 mins" },
  { name: "Noah Taylor", title: "Scrum Master", lateCount: 2, avgLate: "12 mins" },
  { name: "Ava Martin", title: "Business Analyst", lateCount: 6, avgLate: "24 mins" },
  { name: "Mason Moore", title: "Frontend Dev", lateCount: 5, avgLate: "19 mins" },
  { name: "Isabella Clark", title: "Backend Dev", lateCount: 7, avgLate: "26 mins" },
  { name: "Lucas Lewis", title: "UX Researcher", lateCount: 4, avgLate: "20 mins" },
  { name: "Sophia Walker", title: "Engineer", lateCount: 5, avgLate: "21 mins" },
  // { name: "Ethan Hall", title: "Designer", lateCount: 6, avgLate: "23 mins" },
  // { name: "Mia Allen", title: "Manager", lateCount: 3, avgLate: "15 mins" },
  // { name: "James Young", title: "QA Analyst", lateCount: 4, avgLate: "18 mins" },
  // { name: "Charlotte Hernandez", title: "DevOps", lateCount: 6, avgLate: "27 mins" },
  // { name: "Benjamin King", title: "Product Owner", lateCount: 5, avgLate: "25 mins" },
  // { name: "Amelia Wright", title: "Scrum Master", lateCount: 4, avgLate: "22 mins" },
  // { name: "Logan Lopez", title: "Business Analyst", lateCount: 7, avgLate: "29 mins" },
  // { name: "Harper Scott", title: "Frontend Dev", lateCount: 2, avgLate: "14 mins" },
  // { name: "Elijah Green", title: "Backend Dev", lateCount: 6, avgLate: "24 mins" },
  // { name: "Evelyn Adams", title: "UX Researcher", lateCount: 3, avgLate: "16 mins" },
  // { name: "Henry Nelson", title: "Engineer", lateCount: 8, avgLate: "31 mins" },
  // { name: "Abigail Baker", title: "Designer", lateCount: 5, avgLate: "20 mins" },
  // { name: "Sebastian Carter", title: "Manager", lateCount: 6, avgLate: "27 mins" },
  // { name: "Emily Mitchell", title: "QA Analyst", lateCount: 4, avgLate: "19 mins" },
  // { name: "Jackson Perez", title: "DevOps", lateCount: 3, avgLate: "17 mins" },
  // { name: "Scarlett Roberts", title: "Product Owner", lateCount: 5, avgLate: "21 mins" },
  // { name: "Aiden Turner", title: "Scrum Master", lateCount: 2, avgLate: "11 mins" },
  // { name: "Victoria Phillips", title: "Business Analyst", lateCount: 7, avgLate: "30 mins" }
];

export default lateOffenders;
